import { FC } from "react";

import CardItem from "./CardItem";
import CardProvider from "./CardProvider";

import ConditionalTooltip from "../../ConditionalTooltip";
import styles from "./card.module.scss";
import { CardProps } from "./types";

const Card: FC<CardProps> = ({
  className,
  disabled,
  icon,
  title,
  children,
  tooltip,
  subtitle,
  "data-testid": dataTestId
}) => (
  <CardProvider>
    <ConditionalTooltip condition={Boolean(tooltip)} tooltip={tooltip}>
      <div className="w-100">
        <CardItem
          className={className}
          disabled={disabled}
          icon={icon}
          subtitle={subtitle}
          title={title}
          data-testid={dataTestId}
        >
          <div className={styles.card_expandable}>{children}</div>
        </CardItem>
      </div>
    </ConditionalTooltip>
  </CardProvider>
);

export default Card;
